function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="12" height="9" viewBox="0 0 12 9" {...props}><path d="M3.818 7.12L.955 4.298 0 5.239 3.818 9 12 .94 11.045 0z" fillRule="evenodd" /></svg>;
});